import { Component, Input } from '@angular/core';
import { BadgeSizeEnum, BadgeTypeEnum, BadgeVariantEnum } from '@vueling-ng/vy-ds/src/lib/components/globals/badge';
import { IconTextSizeEnum, IconTextTypeEnum } from '@vueling-ng/vy-ds/src/lib/components/globals/icon-text';
import { BookingChannelType, BookingStatus } from '../../models/booking-details.model';

@Component({
  selector: 'app-flight-summary-header',
  templateUrl: './flight-summary-header.component.html',
  styleUrl: './flight-summary-header.component.scss'
})
export class FlightSummaryHeaderComponent {
  @Input()
  public recordLocator = '';
  @Input()
  public paxAmount = 0;
  @Input()
  public status: BookingStatus = 'None';
  @Input()
  public channel: BookingChannelType = 'B2B';
  @Input()
  public gdsRecordLocator: string | undefined = undefined;

  public iconTextTypeEnum = IconTextTypeEnum;
  public iconTextSizeEnum = IconTextSizeEnum;
  public badgeTypeEnum = BadgeTypeEnum;
  public badgeSizeEnum = BadgeSizeEnum;

  public getStatusBadge(): BadgeVariantEnum {
    switch (this.status) {
      case 'PendingFlight': {
        return BadgeVariantEnum.INFO;
      }
      case 'Flown':
      case 'PendingRefund': {
        return BadgeVariantEnum.NEW;
      }
      case 'PendingProcess': {
        return BadgeVariantEnum.WARNING;
      }
      case 'Cancelled':
      case 'Refunded': {
        return BadgeVariantEnum.DISABLED;
      }
      case 'PendingPayment': {
        return BadgeVariantEnum.DANGER;
      }
    }
    return BadgeVariantEnum.INFO;
  }

  public getStatusCopy(): string {
    return `booking_list_component.status_badges.${this.status.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase()}`;
  }
}
